export default __webpack_public_path__ + "static/media/Swap.934eed1b.svg";